<template>
    <div class="house-tile-status" :class="[classStatus]">
<!--        <label v-if="assignable === 0" class="house-tile-status__label">Niet toewijsbaar</label>-->
<!--        <label v-if="assignable === 1" class="house-tile-status__label">Wellicht niet toewijsbaar</label>-->
        <div class="house-tile-status__tile d-flex align-items-center">
            <div v-if="house.images && house.images.main" class="house-tile-status__tile--image w-20 d-none d-lg-flex" :style="{ backgroundImage: 'url(' + house.images.main[0] + ')' }"></div>
            <div class="house-tile-status__tile--content d-inline-flex flex-column w-m-100 w-80">
                <div class="content__title d-flex flex-column">
                    <h3>Bouwnummer {{ house.build_number }}</h3>
                    <h5>{{ house.status }}</h5>
                </div>
                <div class="content__body">
                    <div class="row">
                        <div class="col-4">
                            <div class="house-attribute">
                                <span>Huurprijs</span>
                                <h4>€ {{ house.price_value }} /mnd</h4>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="house-attribute">
                                <span>Slaapkamers</span>
                                <h4>{{ house.characteristics.sleeping_rooms }} slaapkamers</h4>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="house-attribute">
                                <span>Oppervlakte</span>
                                <h4>{{ house.characteristics.surface }}m²</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['house', 'assignable'],
        computed: {
            classStatus(){
                let original = this.house.status.toLowerCase()

                if(original.startsWith('verhuurd')){
                    return 'status-rented'
                }

                if(original.startsWith('beschikbaar')){
                    return 'status-available'
                }

                return 'status-consultation'
            }
        }
    }
</script>

<style lang="scss">
    .house-tile-status__tile--image {
        background-size: cover;
        background-position: center center;
    }
</style>
